// Zonas de envío propio → costo para el cliente (precarga del popup de Nueva venta).
//
// Regla (10/10/2026, editable acá): la zona sale del PARTIDO que devuelve Google al elegir la
// dirección del autocompletado (administrative_area_level_2), no del texto.
//   CABA                       → $6.800
//   AMBA (1° y 2° cordón)      → $12.500
//   AMBA lejos (3° cordón)     → $14.000
//   resto del país             → ninguno (se elige a mano o va por otro canal)
// Si cambian las tarifas o un partido pasa de grupo, se cambia SOLO este archivo.

export type ShippingZone = 'caba' | 'amba' | 'amba_lejos' | 'fuera';

export const ZONE_PRICE: Record<Exclude<ShippingZone, 'fuera'>, number> = {
  caba: 6800,
  amba: 12500,
  amba_lejos: 14000,
};

export const ZONE_LABEL: Record<ShippingZone, string> = {
  caba: 'CABA', amba: 'AMBA', amba_lejos: 'AMBA lejos', fuera: 'fuera de AMBA',
};

// Partidos del conurbano, normalizados (minúsculas, sin acentos).
const AMBA = [
  // 1° cordón
  'vicente lopez', 'san isidro', 'san martin', 'general san martin', 'tres de febrero', 'hurlingham', 'ituzaingo',
  'moron', 'la matanza', 'lomas de zamora', 'lanus', 'avellaneda', 'quilmes',
  // 2° cordón
  'san fernando', 'tigre', 'malvinas argentinas', 'jose c. paz', 'jose c paz', 'san miguel', 'merlo', 'moreno',
  'esteban echeverria', 'ezeiza', 'almirante brown', 'florencio varela', 'berazategui',
];
const AMBA_LEJOS = [
  // 3° cordón
  'pilar', 'escobar', 'general rodriguez', 'marcos paz', 'canuelas', 'san vicente', 'presidente peron',
  'la plata', 'berisso', 'ensenada', 'lujan', 'exaltacion de la cruz', 'campana', 'zarate', 'brandsen',
  'coronel brandsen', 'general las heras',
];

const norm = (s: string | null | undefined) =>
  String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/^partido de\s+/, '').trim();

/** Zona a partir de los componentes de dirección de Google Places (New). */
export function zoneFromComponents(components: { longText?: string; types?: string[] }[] | null | undefined): ShippingZone | null {
  if (!components?.length) return null;
  const get = (t: string) => components.find(c => (c.types || []).includes(t))?.longText || null;
  const prov = norm(get('administrative_area_level_1'));
  if (prov.includes('ciudad autonoma') || prov === 'caba' || prov.includes('capital federal')) return 'caba';
  if (!prov.includes('buenos aires')) return 'fuera';
  const partido = norm(get('administrative_area_level_2'));
  if (AMBA.includes(partido)) return 'amba';
  if (AMBA_LEJOS.includes(partido)) return 'amba_lejos';
  return 'fuera';
}
